import React from 'react'

const Faq = () => {
  return (
    <section className='container py-10'>
        <h1 className='heading-one !mb-7'>FAQ's</h1>
        <div className='w-full bg-white rounded-md p-4 max-w-[440px]'>
            <p className="text-center font-poppins font-semibold text-lg pb-4">Frequently Asked Questions</p>
            <form className='space-y-8'>
                <div className='flex flex-col gap-1'>
                    <label htmlFor='question' className='font-poppins font-semibold text-lg'>Question</label>
                    <input type='text' placeholder='Add Question'
                     className='w-full border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' 
                    />
                </div>
                <div className='flex flex-col gap-1'>
                    <label htmlFor='answer' className='font-poppins font-semibold text-lg' >Answer</label>
                    <textarea  cols={5} maxLength={50}
                     className='w-full border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' 
                    ></textarea>
                </div>
                <div className='flex justify-end gap-6 items-center'>
                     <button className='bg-primary-yellow-500 rounded-md text-white p-2 max-w-48 font-poppins font-medium text-base flex justify-center items-center'>Add</button>
                     <button className='bg-primary-yellow-500 rounded-md text-white p-2 max-w-48 flex justify-center items-center font-poppins font-meduim text-base'>Clear</button>
                </div>
            </form>
        </div>
    </section>
  )
}

export default Faq